<template>
  <div class="container">
    <form @submit.prevent="submit" class="box-container">
      <div class="field">
        <label>Event Name</label>
        <input type="text" v-model="eventName" placeholder="Enter Event Name" />
      </div>
      <div class="field">
        <label>Event Location</label>
        <input type="text" v-model="eventLocation" placeholder="Enter Event Location" />
      </div>
      <div class="field">
        <label>Event Start Date</label>
        <datepicker v-model="eventStartDate" placeholder="Enter Event Start Date"></datepicker>
      </div>
      <div class="field">
        <label>Event End Date</label>
        <datepicker v-model="eventEndDate" placeholder="Enter Event End Date"></datepicker>
      </div>

      <div class="btn-container">
        <button
          type="submit"
          :disabled="isDisabled"
          :class="{'disabled': isDisabled}"
          class="loadmore"
        >ADD EVENT</button>
      </div>

      <div class="alert alert-success" v-if="showAlert">You have successfully added a new event!</div>
    </form>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker
  },
  data() {
    return {
      eventName: "",
      eventLocation: "",
      eventStartDate: "",
      eventEndDate: "",
      showAlert: false
    };
  },
  computed: {
    isDisabled() {
      if (
        this.eventName !== "" &&
        this.eventLocation !== "" &&
        this.eventEndDate !== "" &&
        this.eventEndDate !== ""
      ) {
        return false;
      }

      return true;
    }
  },
  methods: {
    submit() {
      const event = {
        name: this.eventName,
        address: this.eventLocation,
        startDate: this.eventStartDate,
        endDate: this.eventEndDate
      };
      this.$store.dispatch("addEvent", event).then(() => {
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
        this.eventName = "";
        this.eventLocation = "";
        this.eventStartDate = "";
        this.eventEndDate = "";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box-container {
  width: 500px;
  padding: 15px;
}

input {
  flex: 1;
  margin-left: 20px;

  &:focus {
    outline: none;
  }
}

label {
  width: 135px;
}
</style>